import { gql } from '@apollo/client';

const PartnerLocationInfo = gql`
  fragment PartnerLocationInfo on PartnerLocation {
    id
    name
    email
    phone
    website
    active
    imageUrl
    legacyId
    isAllowedFreeTrial
    insertImageUrl
    enablePaidInOffice
    taxjarCheckoutEnabled
    hiresLogoUrl
    perArchEotFee
    priceBookId
    priceBook {
      id
      name
    }
    scannerBrandId
    scannerBrand {
      id
      name
    }
    address {
      id
      address
      address2
      city
      region
      postalCode
      country
      latitude
      longitude
    }
    partnerShippingAddress {
      id
      address
      address2
      city
      region
      postalCode
      country
      latitude
      longitude
    }
    partnerOrganizationId
    partnerOrganization {
      id
      name
    }
    createdAt
    updatedAt
  }
`;

export default PartnerLocationInfo;
